/**
 * The FROZEN §4 wire shapes for the user tasklist ("Pendências").
 *
 * Single-sourced here because three implementations must agree on them: the
 * LexIDE pane (read-write, gateway RPC), the LexPortal platform-admin view
 * (read-only, REST proxy), and the runtime store that produces them. Two SPAs
 * previously carried hand-copied duplicates; see `comparator.ts` for what that
 * cost.
 *
 * These mirror `lexiun-core/src/tasklist/schema.ts` on the wire. They are
 * deliberately plain types, not Zod schemas: the runtime validates on write,
 * and a second validation layer in the SPAs would only add a place to drift.
 */
/** Terminal statuses — the only ones `archive` accepts. */
export const TERMINAL_STATUSES = ["done", "dropped"];
/** `true` for the two statuses that end a task's life. */
export function isTerminalStatus(status) {
    return status === "done" || status === "dropped";
}
//# sourceMappingURL=types.js.map